import React, { FC, useCallback, useEffect } from "react";
import { API_URL } from "../../../../actions/settings";

async function getData(token: string, id: any) {
  return fetch(`${API_URL}/benchmark/data/${id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
  }).then((res) => {
    return res.json();
  });
}

interface IProps {
  building?: string | null;
  data: any;
  setData: any;
  setSelectedData?: any;
  reload: boolean;
  setReload: any;
}

const AnnualEnergyTargetSavedData: FC<IProps> = (props) => {
  const { building, data, setData, setSelectedData, reload, setReload } = props;
  const fetchData = useCallback(
    async (reload: boolean) => {
      const token = `Token ${(localStorage.getItem("token") || "").slice(
        1,
        -1
      )}`;
      const res = await getData(token, building);
      if (res) {
        setData(res.data);

        if (!reload && res.data.length > 0 && setSelectedData) {
          setSelectedData(res.data[0]);
        }
      }
    },
    [building, setData, setSelectedData]
  );

  useEffect(() => {
    fetchData(false);
  }, [fetchData]);

  useEffect(() => {
    if (reload) {
      fetchData(reload);
      setReload(false);
    }
  }, [fetchData, reload, setReload]);

  return (
    <div
      className="pc-only"
      style={{
        border: "black 2px solid",
        maxHeight: "100%",
        padding: "1rem",
        overflowY: "auto",
      }}
    >
      Previous Results:
      <br />
      <br />
      {data ? (
        data.map((item: any, index: number) => (
          <div
            key={index}
            className="annual-target-row"
            onClick={() => (setSelectedData ? setSelectedData(item) : null)}
          >
            <div style={{ display: "flex" }}>
              <div className="label">
                kWh/ft<sup>2</sup>:
              </div>
              <div> {item.kwh_data[1].kwh_per_sqft}</div>
            </div>
            <div style={{ display: "flex" }}>
              <div className="label">
                Therms/ft<sup>2</sup>:
              </div>
              <div> {item.therms_data[1].therms_per_sqft}</div>
            </div>
            <div style={{ display: "flex" }}>
              <div className="label">Target EUI:</div>
              <div> {item.target_eui}</div>
            </div>
            <hr />
          </div>
        ))
      ) : (
        <p>No previous data available.</p>
      )}
    </div>
  );
};

export default AnnualEnergyTargetSavedData;
